import { Button } from "@/shared/components/button";
import { cn } from "@/shared/lib/utils";

export interface PillTab<T extends string> {
  id: T;
  label: string;
}

interface PillTabsProps<T extends string> {
  tabs: PillTab<T>[];
  active: T;
  onChange: (id: T) => void;
  /** Accessible name for the tablist. */
  label: string;
  className?: string;
}

// The app's pill "splitter" — same markup and classes as the Document Panel's
// Issues / Parsed Data / View PDF Data / View Original File switch
// (UploadDetailPanel). Use this for any tab-like switch instead of antd Tabs.
const ACTIVE = "!h-7 !rounded-full !border-0 !bg-[#0A2947] !px-4 !text-xs !font-extrabold !text-white hover:!bg-[#0A2947]";
const INACTIVE = "!h-7 !rounded-full !border-0 !bg-transparent !px-4 !text-xs !font-extrabold !text-[#0A2947] hover:!bg-[#F3F4F6]";

export function PillTabs<T extends string>({ tabs, active, onChange, label, className }: PillTabsProps<T>) {
  return (
    <div
      className={cn("inline-flex flex-wrap items-center gap-1 rounded-full border border-[#D1D5DB] bg-white p-1", className)}
      role="tablist"
      aria-label={label}
    >
      {tabs.map(({ id, label: tabLabel }) => (
        <Button
          key={id}
          role="tab"
          aria-selected={active === id}
          onClick={() => onChange(id)}
          className={active === id ? ACTIVE : INACTIVE}
        >
          {tabLabel}
        </Button>
      ))}
    </div>
  );
}
